<script>
import { Bar } from 'vue-chartjs';

export default {
	extends: Bar,
	props: {
		display: {
			type: Boolean,
			default: false,
		},
		labels: {
			type: Array,
			default: () => [],
		},
		data: {
			type: Array,
			default: () => [],
		},
		color: {
			type: String,
			default: '#f87979',
		},
		label: {
			type: String,
			default: 'Kilos',
		},
		link: {
			type: String,
		},
	},
	data() {
		return {
			datachart: {
				labels: this.labels,
				datasets: [
					{
						label: this.label,
						backgroundColor: this.hexToRGBA(this.color, 0.2),
						borderColor: this.color,
						borderWidth: 1,
						barThickness: 'flex',
						data: this.data,
					},
				],
			},
		};
	},
	computed: {
		activeProfile() {
			return this.$store.state.perfil.activeProfile ? this.$store.state.perfil.activeProfile : this.$route.path.slice(1, 2);
		},
	},
	mounted() {
		this.renderChart(this.datachart, {
			responsive: true,
			maintainAspectRatio: false,
			onClick: this.handle,
			legend: {
				display: false,
			},
			scales: {
				xAxes: [{ display: this.display }],
			},
		});
	},
	methods: {
		handle(point, event) {
			const item = event[0];
			this.$emit('on-receive', {
				index: item._index,
				backgroundColor: item._view.backgroundColor,
				value: `${this.$route.path.slice(1, 2)}/${this.link}/${this.labels[item._index]}`,
			});
		},
		hexToRGBA(h, a) {
			let r = 0,
				g = 0,
				b = 0;

			if (h.length == 4) {
				r = '0x' + h[1] + h[1];
				g = '0x' + h[2] + h[2];
				b = '0x' + h[3] + h[3];
			} else if (h.length == 7) {
				r = '0x' + h[1] + h[2];
				g = '0x' + h[3] + h[4];
				b = '0x' + h[5] + h[6];
			}

			return `rgba(${+r}, ${+g}, ${+b}, ${a})`;
		},
	},
};
</script>
